import { type ReactElement, useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";

import { useAuth } from "./useAuth";
import { accountsApi } from "@/lib/accounts-api";
import { queryKeys } from "@/config/query-keys";
import { WarehouseApi } from "@/lib/warehouse-api";

export function CustomerRoute({ children }: { children: ReactElement }) {
  const { customers, selectedCustomer } = useAuth();
  const queryClient = useQueryClient();
  const hasCustomerSession = accountsApi.hasActiveCustomerSession();

  useEffect(() => {
    if (selectedCustomer || customers.length === 1 || hasCustomerSession) {
      queryClient.prefetchQuery({
        queryKey: queryKeys.facilities.list(),
        queryFn: () => WarehouseApi.getFacilities(),
        staleTime: Infinity,
      });
    }
  }, [selectedCustomer, customers, hasCustomerSession, queryClient]);

  if (customers.length > 1 && !selectedCustomer && !hasCustomerSession) {
    return <Navigate to="/login" replace />;
  }

  return children;
}
